import React from "react";

import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import NotificationsOffOutlinedIcon from "@mui/icons-material/NotificationsOffOutlined";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import dayjs from "dayjs";

// The delivery switches sit at the foot of the dialog's scrolling content, far
// enough down that it was easy to share without realising nothing would be sent.
// This restates the outcome beside the share button, where it cannot be missed,
// and scrolls the switches into view when clicked.
export default function ShareDialogDeliverySummary({
    embargoNotifications,
    fromDate,
    onReview,
    recipientCount,
    sendEmails,
    sendNotifications,
}) {
    const deliveryEnabled = sendNotifications || sendEmails;
    const willNotify = deliveryEnabled && recipientCount > 0;

    function buildSummary() {
        if (!deliveryEnabled) {
            return "No notifications will be sent";
        }

        // Delivery is switched on but there is nobody to deliver to, which fails
        // just as silently as having the switches off.
        if (recipientCount === 0) {
            return "No recipients yet, so nothing will be sent";
        }

        let method = "Email";
        if (sendNotifications && sendEmails) {
            method = "Notification + email";
        } else if (sendNotifications) {
            method = "Notification";
        }

        const people = `${recipientCount} ${
            recipientCount === 1 ? "person" : "people"
        }`;
        const schedule = embargoNotifications
            ? ` from ${dayjs(fromDate).format("DD/MM/YYYY")}`
            : "";

        return `${method} to ${people}${schedule}`;
    }

    return (
        <Tooltip title="Review notification settings">
            <Button
                onClick={onReview}
                color="inherit"
                size="small"
                startIcon={
                    willNotify ? (
                        <NotificationsActiveOutlinedIcon fontSize="small" />
                    ) : (
                        <NotificationsOffOutlinedIcon fontSize="small" />
                    )
                }
                sx={{
                    mr: "auto",
                    px: 1,
                    textAlign: "left",
                    textTransform: "none",
                    fontWeight: 700,
                    lineHeight: 1.3,
                    color: willNotify ? "text.secondary" : "warning.dark",
                    "& .MuiButton-startIcon": {
                        color: willNotify ? "text.secondary" : "warning.main",
                    },
                }}
            >
                {buildSummary()}
            </Button>
        </Tooltip>
    );
}
